import RadioGroup from '@material-ui/core/RadioGroup';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { reduxForm } from 'redux-form';
import { V364_SYNC_OPTIONS } from '../../../_config/consts';
import MDRadioButtonView from '../Elements/MDRadioButtonsGroup/MDRadioButtonView.js';

@reduxForm({ form: 'SmartLocksSynchV364Form' })
class SmartLocksSynchV364Form extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      syncOptionSelected: V364_SYNC_OPTIONS.RENAME,
    };
  }

  onHandleRadioChange(value) {
    this.setState({ syncOptionSelected: value });
    const { onSyncOptionChange } = this.props;
    if (onSyncOptionChange) {
      onSyncOptionChange(value);
    }
  }

  render() {
    const { syncOptionSelected } = this.state;
    const syncOptions = [
      { value: V364_SYNC_OPTIONS.RENAME, label: <Entity entity="syncOptionRename" /> },
      { value: V364_SYNC_OPTIONS.DELETE_AND_RECREATE, label: <Entity entity="syncOptionDeleteAndRecreate" /> }
    ];

    return (
      <div style={{ padding: 20 }}>
        <h4 style={{ marginBottom: 20, color: '#3f3f3f' }}>
          <Entity entity="selectSyncOption" />
        </h4>
        <RadioGroup
          value={syncOptionSelected}
          style={{ flexDirection: 'column' }}
        >
          {_.map(syncOptions, (option, index) => (
            <MDRadioButtonView
              key={index}
              checked={syncOptionSelected === option.value}
              handleChange={() => this.onHandleRadioChange(option.value)}
              value={option.value}
              label={option.label}
              labelStyle={{ margin: 0, fontSize: 16 }}
            />
          ))}
        </RadioGroup>
      </div>
    );
  }
} 

export default SmartLocksSynchV364Form;
